import * as fs from "fs";

import { Config, ResultsLevel } from "../../config";
import { Disposition } from "../../job";
import Execution, { Events, FunctionResult, ItemResult } from "../execution";

export default class ResultsLog {
	execution: Execution;
	constructor(execution: Execution) {
		this.execution = execution;

		if (this.execution.cfg.results.filePath !== undefined) {
			if (this.execution.cfg.results.includeConfigInFile)
				this.config = this.execution.cfg;

			this.execution.on(Events.Started, e => {
				this.startedAt = e.startedAt;
			});
			this.execution.on(Events.Completed, e => {
				this.completedAt = e.completedAt;
				this.disposition = e.disposition;
				this.successfulItemCount = this.execution.successfulItemCount;
				this.failedItemCount = this.execution.failedItemCount;
			});
			this.execution.on(Events.ItemsCounted, e => {
				this.totalItemCount = e.count;
			});
			this.execution.on(Events.FunctionCompleted, e => {
				if (
					e.result.error !== undefined ||
					this.execution.cfg.results.level <= ResultsLevel.Successful
				) {
					if (this.execution.cfg.results.level !== ResultsLevel.Trace)
						e.result.duration = undefined;
					this.methods.push(e.result);
				}
			});
			this.execution.on(Events.ItemCompleted, e => {
				if (
					e.result.error !== undefined ||
					this.execution.cfg.results.level <= ResultsLevel.Successful
				) {
					if (this.execution.cfg.results.level !== ResultsLevel.Trace)
						e.result.duration = undefined;
					this.items.push(e.result);
				}
			});
		}
	}

	configPath: string;
	config: Config;
	startedAt: Date;
	completedAt: Date;
	disposition: Disposition;
	totalItemCount: number;
	successfulItemCount: number;
	failedItemCount: number;
	methods: FunctionResult[] = [];
	items: ItemResult[] = [];

	write() {
		if (this.execution.cfg.results.filePath !== undefined) {
			fs.writeFile(
				this.execution.cfg.results.filePath,
				JSON.stringify(this.omitKeys(["execution"])),
				_ => {}
			);
		}
	}

	omitKeys(keys: string[]): unknown {
		const dup: { [id: string]: unknown } = {};
		for (const key in this) {
			if (!keys.includes(key)) {
				dup[key] = this[key];
			}
		}
		return dup;
	}
}
